/* Terrene House — animations.js v6.0
   Light theme. Emil Kowalski design engineering.
   GSAP ScrollTrigger + clip-path reveals + lerp cursor */

(function () {
  'use strict';

  /* ── Custom easing curves (Emil Kowalski philosophy) ── */
  var EXPO = 'expo.out';           /* cubic-bezier(0.16, 1, 0.3, 1) */
  var EASE = 'power3.out';

  /* ─── WAIT FOR GSAP ──────────────────────────── */
  /* ─── PRODUCT PAGE V2 ANIMATIONS ────────────────────────── */
  /* Emil principles applied:
     - clip-path reveals > opacity for image-heavy elements
     - stagger 50ms between siblings — feels cascaded, not chaotic
     - ease: EXPO (cubic-bezier 0.16,1,0.3,1) for all entrances
     - never animate layout properties (height/padding) */
  function initProductPageV2() {

    /* Features bento — same pop-up as homepage bento */
    var pd2Bento = document.querySelector('.th-pd2-bento');
    if (pd2Bento) {
      var bentoCells = pd2Bento.querySelectorAll('.th-pd2-bc');
      if (bentoCells.length) {
        gsap.set(bentoCells, { opacity: 0, y: 40, scale: 0.95, transformOrigin: 'center bottom' });
        ScrollTrigger.create({
          trigger: pd2Bento,
          start: 'top 82%',
          once: true,
          onEnter: function () {
            gsap.to(bentoCells, {
              opacity: 1, y: 0, scale: 1,
              stagger: { each: 0.06, from: 'start' },
              duration: 0.68, ease: EXPO,
              clearProps: 'transform,opacity'
            });
          }
        });
      }
    }

    /* Spec cells — stagger clip reveal from bottom */
    var specCells = document.querySelectorAll('.th-spec-cell');
    if (specCells.length) {
      gsap.set(specCells, { clipPath: 'inset(100% 0 0 0)' });
      ScrollTrigger.create({
        trigger: document.querySelector('.th-pd2-specs-grid'),
        start: 'top 85%',
        once: true,
        onEnter: function () {
          gsap.to(specCells, {
            clipPath: 'inset(0% 0 0 0)',
            stagger: { each: 0.08, from: 'start' },
            duration: 0.75, ease: EXPO,
            clearProps: 'clipPath'
          });
        }
      });
    }

    /* How-to steps — fade + slide from left, staggered */
    var steps = document.querySelectorAll('.th-pd2-step');
    if (steps.length) {
      gsap.set(steps, { opacity: 0, x: -20 });
      ScrollTrigger.create({
        trigger: document.querySelector('.th-pd2-steps'),
        start: 'top 85%',
        once: true,
        onEnter: function () {
          gsap.to(steps, {
            opacity: 1, x: 0,
            stagger: { each: 0.07, from: 'start' },
            duration: 0.65, ease: EXPO,
            clearProps: 'transform,opacity'
          });
        }
      });
    }

    /* Section headings — clip reveal */
    document.querySelectorAll('.th-pd2-sec-hd').forEach(function (hd) {
      var children = hd.children;
      if (!children.length) return;
      gsap.set(children, { opacity: 0, y: 16 });
      ScrollTrigger.create({
        trigger: hd,
        start: 'top 88%',
        once: true,
        onEnter: function () {
          gsap.to(children, {
            opacity: 1, y: 0,
            stagger: 0.06,
            duration: 0.6, ease: EASE,
            clearProps: 'transform,opacity'
          });
        }
      });
    });

    /* Collection v2 cards — stagger pop-up on page load */
    var cl2Cards = document.querySelectorAll('.th-cl2-card');
    if (cl2Cards.length) {
      gsap.set(cl2Cards, { opacity: 0, y: 32 });
      ScrollTrigger.create({
        trigger: document.getElementById('th-cl2-grid'),
        start: 'top 90%',
        once: true,
        onEnter: function () {
          gsap.to(cl2Cards, {
            opacity: 1, y: 0,
            stagger: { each: 0.05, from: 'start' },
            duration: 0.60, ease: EXPO,
            clearProps: 'transform,opacity'
          });
        }
      });
    }
  }

  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(init, 50);
      return;
    }
    gsap.registerPlugin(ScrollTrigger);
    initManifesto();
    initBentoCells();
    initHeader();
    initHero();
    initClipReveals();
    initIngredientAnatomy();   /* handles desktop GSAP pin */
    initSectionReveals();
    initProductPageV2();
    initCursor();

    /* Refresh after layout settles — fonts, images, setHeight() all mutate
       the DOM after GSAP registers triggers; without this refresh the pin
       fires at wrong scroll positions and appears broken */
    requestAnimationFrame(function () { ScrollTrigger.refresh(); });
    window.addEventListener('load', function () { ScrollTrigger.refresh(); }, { once: true });

    /* Theme editor only: Shopify fires these when sections are added,
       reordered, or removed. Re-measure all ScrollTriggers (pins + reveals)
       so reordering doesn't leave pinned sections in a broken state. */
    ['shopify:section:load', 'shopify:section:reorder', 'shopify:section:unload'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        requestAnimationFrame(function () {
          if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
        });
      });
    });
  }

  /* Mobile reveals run independently — no GSAP dependency */
  document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 768) initMobileReveal();
  });

  /* ─── HERO CAROUSEL ─────────────────────────── */
  /* Full-screen crossfade carousel with progress bar.
     Emil: progress bar uses CSS transition driven by JS — stays on GPU. */
  function initHeroCarousel() {
    document.querySelectorAll('.th-hc-wrap').forEach(function (wrap) {
      var slides   = wrap.querySelectorAll('.th-hc-slide');
      var dots     = wrap.querySelectorAll('.th-hc-dot');
      var bar      = wrap.querySelector('.th-hc-progress-bar');
      var counter  = wrap.querySelector('.th-hc-slide-count .th-hc-count-current');
      var prevBtn  = wrap.querySelector('.th-hc-arrow--prev');
      var nextBtn  = wrap.querySelector('.th-hc-arrow--next');
      if (!slides.length) return;

      var speed  = parseInt(wrap.dataset.speed || '5000', 10);
      var cur    = 0;
      var timer  = null;
      var paused = false;

      function pad(n) { return n < 10 ? '0' + n : String(n); }

      function goTo(idx) {
        slides[cur].classList.remove('is-active');
        if (dots[cur]) dots[cur].classList.remove('is-active');
        cur = (idx + slides.length) % slides.length;
        slides[cur].classList.add('is-active');
        if (dots[cur]) dots[cur].classList.add('is-active');
        if (counter)  counter.textContent = pad(cur + 1);
        resetBar();
      }

      function resetBar() {
        if (!bar) return;
        bar.style.transition = 'none';
        bar.style.width = '0%';
        /* Double rAF ensures the browser paints the reset before starting */
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            bar.style.transition = 'width ' + speed + 'ms linear';
            bar.style.width = '100%';
          });
        });
      }

      function startTimer() {
        clearInterval(timer);
        if (!paused) timer = setInterval(function () { goTo(cur + 1); }, speed);
      }

      /* Dot clicks */
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goTo(i);
          startTimer();
        });
      });

      /* Arrow clicks */
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(cur - 1); startTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(cur + 1); startTimer(); });

      /* Pause on hover */
      wrap.addEventListener('mouseenter', function () {
        paused = true;
        clearInterval(timer);
        if (bar) { bar.style.transition = 'none'; }
      });
      wrap.addEventListener('mouseleave', function () {
        paused = false;
        startTimer();
      });

      /* Touch swipe */
      var touchX = 0;
      wrap.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
      wrap.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 40) { goTo(dx < 0 ? cur + 1 : cur - 1); startTimer(); }
      }, { passive: true });

      resetBar();
      startTimer();
    });
  }

  /* ─── MANIFESTO WORD REVEAL ──────────────────── */
  /* Uses ScrollTrigger.onUpdate with direct element.style.opacity —
     bypasses GSAP tween state entirely, guaranteed to fire on every
     scroll frame. Words cascade from first to last as progress grows.
     Reverses automatically because onUpdate fires on scroll-up too. */
  function initManifesto() {
    document.querySelectorAll('.th-manifesto').forEach(function (section) {
      var words = section.querySelectorAll('.mf-word');
      if (!words.length) return;

      /* Ink colour follows the page: --mf-ink (R, G, B) lets a dark
         page remap the fill; defaults to the light-theme dark ink. */
      var ink = (getComputedStyle(section).getPropertyValue('--mf-ink') || '').trim() || '12,19,8';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        words.forEach(function (w) { w.style.color = 'rgba(' + ink + ',1)'; });
        return;
      }

      /* Faint grey to start; fills to full ink ONCE when the block enters
         the viewport, sweeping first word to last over a fixed time.
         Not tied to scroll position. */
      gsap.set(words, { color: 'rgba(' + ink + ',0.12)' });

      ScrollTrigger.create({
        trigger: section,
        start: 'top 70%',
        once: true,
        onEnter: function () {
          gsap.to(words, {
            color: 'rgba(' + ink + ',1)',
            ease: 'none',
            duration: 0.45,
            stagger: { amount: 1.5, from: 'start' }
          });
        }
      });
    });
  }

  /* ─── BENTO CELLS POP-UP REVEAL ───────────────────── */
  function initBentoCells() {
    var bentoGrid = document.querySelector('.th-bento-grid');
    if (bentoGrid) {
      var cells = bentoGrid.querySelectorAll('.th-bento-cell');

      /* Set hidden state immediately so there's no flash */
      gsap.set(cells, { opacity: 0, y: 52, scale: 0.93, transformOrigin: 'center bottom' });

      ScrollTrigger.create({
        trigger: bentoGrid,
        start: 'top 80%',
        once: true,
        onEnter: function () {
          gsap.to(cells, {
            opacity: 1,
            y: 0,
            scale: 1,
            stagger: { each: 0.07, from: 'start' },
            duration: 0.72,
            ease: EXPO,
            clearProps: 'transform,opacity'
          });
        }
      });
    }

    /* Duo cards */
    gsap.utils.toArray('.th-duo-card').forEach(function (card, i) {
      gsap.from(card, {
        scrollTrigger: { trigger: card, start: 'top 85%' },
        opacity: 0,
        y: 40,
        duration: 0.85,
        delay: i * 0.10,
        ease: EXPO
      });
    });

    /* Brand feature sections */
    gsap.utils.toArray('.th-bf-copy').forEach(function (copy) {
      gsap.from(copy.children, {
        scrollTrigger: { trigger: copy, start: 'top 80%' },
        opacity: 0,
        y: 24,
        stagger: 0.09,
        duration: 0.75,
        ease: EASE
      });
    });
  }

  /* ─── HEADER SCROLL STATE ────────────────────── */
  function initHeader() {
    var header = document.querySelector('.th-header');
    if (!header) return;
    var past = false;
    window.addEventListener('scroll', function () {
      var now = window.scrollY > 60;
      if (now !== past) {
        past = now;
        header.classList.toggle('th-header-scrolled', now);
      }
    }, { passive: true });
  }

  /* ─── HERO LOAD ANIMATION ────────────────────── */
  function initHero() {
    var hero = document.querySelector('.th-hh-wrap');
    if (!hero) return;

    var lines    = hero.querySelectorAll('.th-hh-line');
    var eyebrow  = hero.querySelector('.th-hh-eyebrow');
    var body     = hero.querySelector('.th-hh-body');
    var proof    = hero.querySelector('.th-hh-proof');
    var ctas     = hero.querySelector('.th-hh-ctas');
    var products = hero.querySelector('.th-hh-products');
    var glow     = hero.querySelector('.th-hh-glow');
    var bottom   = hero.querySelector('.th-hh-bottom');
    var specimen = hero.querySelector('.th-hh-specimen');
    var badge    = hero.querySelector('.th-hh-badge');

    var tl = gsap.timeline({ delay: 0.10 });

    /* Product packages — clip-path reveal from bottom (Emil: never scale(0)) */
    if (products) {
      gsap.set(products, { clipPath: 'inset(100% 0 0 0)' });
      tl.to(products, {
        clipPath: 'inset(0% 0 0 0)',
        opacity: 1,
        duration: 1.4,
        ease: EXPO
      }, 0);
      tl.from(products.querySelectorAll('.th-hh-pkg'), {
        y: 28,
        opacity: 0,
        stagger: 0.10,
        duration: 1.0,
        ease: EXPO
      }, 0.15);
    }

    if (glow) {
      tl.from(glow, { opacity: 0, scale: 0.7, duration: 1.8, ease: EASE }, 0);
    }

    /* Eyebrow */
    if (eyebrow) {
      tl.from(eyebrow, { opacity: 0, y: 10, duration: 0.6, ease: EASE }, 0.35);
    }

    /* Headline: each line slides up from below (parent overflow:hidden clips it) */
    if (lines.length) {
      tl.from(lines, {
        yPercent: 105,
        stagger: 0.08,
        duration: 0.85,
        ease: EXPO
      }, 0.50);
    }

    /* Body, proof, CTAs stagger */
    var copyEls = [body, proof, ctas].filter(Boolean);
    if (copyEls.length) {
      tl.from(copyEls, {
        opacity: 0,
        y: 16,
        stagger: 0.08,
        duration: 0.70,
        ease: EASE
      }, 0.85);
    }

    /* Corner labels */
    var corners = [specimen, badge, bottom].filter(Boolean);
    if (corners.length) {
      tl.from(corners, { opacity: 0, duration: 0.7, ease: EASE, stagger: 0.05 }, 1.0);
    }
  }

  /* ─── CLIP-PATH IMAGE REVEALS ────────────────── */
  /* Images and sections with .th-clip-reveal enter via
     inset() clip-path. IntersectionObserver triggers the class.
     Emil: clip-path reveal > opacity fade for images always. */
  function initClipReveals() {
    var targets = document.querySelectorAll(
      '.th-clip-reveal, .th-clip-reveal-right, img.th-prod-img-wrap img, .th-prod-img-wrap'
    );

    if (!('IntersectionObserver' in window)) {
      /* Fallback: reveal everything immediately */
      targets.forEach(function (el) {
        el.classList.add('th-clip-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('th-clip-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '-40px 0px' });

    document.querySelectorAll('.th-clip-reveal, .th-clip-reveal-right').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ─── MOBILE SCROLL REVEALS (IntersectionObserver) ─── */
  function initMobileReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.th-bf-glass').forEach(function (g) {
        g.classList.add('is-visible');
      });
      return;
    }

    /* Brand feature: glass bottom panel animates in when card is 30% in view */
    var bfCards = document.querySelectorAll('.th-bf-card');
    if (bfCards.length) {
      var bfObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var glass = entry.target.querySelector('.th-bf-glass');
          if (glass) glass.classList.add('is-visible');
          bfObs.unobserve(entry.target);
        });
      }, { threshold: 0.28 });
      bfCards.forEach(function (card) { bfObs.observe(card); });
    }
  }

  /* ─── INGREDIENT ANATOMY — PINNED SCROLL (all viewports) ────── */
  function initIngredientAnatomy() {
    var section = document.querySelector('.ia-section');
    if (!section) return;

    var frames    = gsap.utils.toArray('.ia-frame');
    var pips      = gsap.utils.toArray('.ia-pip');
    var bgNum     = document.getElementById('ia-bg-num');
    if (!frames.length) return;

    var HEADER_H  = 72;
    var numFrames = frames.length;
    var curIdx    = 0;

    /* .ia-section is a TALL scroll container; its .ia-sticky child fills the
       screen and sticks (CSS position:sticky — no GSAP pin-spacer, so editor
       reordering can't break it). Height = one viewport + scroll distance for
       every frame. */
    var stickyEl  = section.querySelector('.ia-sticky');
    /* Mobile needs MORE scroll per frame than desktop (touch flicks carry
       momentum) so one swipe ≈ one frame instead of blowing through all 8. */
    var PER_FRAME = window.innerWidth < 768 ? 520 : 560;
    function setHeight() {
      PER_FRAME = window.innerWidth < 768 ? 520 : 560;
      /* Measure the sticky child's real rendered height (100svh in px) rather
         than window.innerHeight, which differs from svh on mobile and causes
         jank/trailing scroll. */
      var vp = (stickyEl && stickyEl.offsetHeight) ? stickyEl.offsetHeight : window.innerHeight;
      section.style.height = (vp + numFrames * PER_FRAME) + 'px';
    }
    setHeight();
    /* Mobile browsers fire resize when the URL bar shows/hides while you
       scroll (a HEIGHT-only change). Rebuilding the section height mid-scroll
       makes the progress jump and breaks the frames when scrolling back up,
       so only react to real WIDTH changes (rotation / desktop resize). */
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      setHeight();
      if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
    }, { passive: true });

    frames.forEach(function (frame, i) {
      var name = frame.querySelector('.ia-name');
      var fn   = frame.querySelector('.ia-function');
      if (i === 0) {
        gsap.set(frame, { opacity: 1, y: 0, pointerEvents: 'auto' });
        if (name) gsap.set(name, { yPercent: 0 });
        if (fn)   gsap.set(fn,   { opacity: 1, y: 0 });
      } else {
        gsap.set(frame, { opacity: 0, y: 40, pointerEvents: 'none' });
        if (name) gsap.set(name, { yPercent: 60 });
        if (fn)   gsap.set(fn,   { opacity: 0, y: 12 });
      }
    });

    function showFrame(newIdx, dir) {
      if (newIdx === curIdx) return;

      var oldFrame = frames[curIdx];
      var newFrame = frames[newIdx];
      var name     = newFrame.querySelector('.ia-name');
      var fn       = newFrame.querySelector('.ia-function');

      /* Sweep: fast flicks can skip frames mid-tween — force every frame
         that isn't entering or exiting fully hidden so none get stuck. */
      frames.forEach(function (f, j) {
        if (j !== newIdx && j !== curIdx) gsap.set(f, { opacity: 0, pointerEvents: 'none' });
      });

      /* Exit — asymmetric: faster out than in (Emil: slow enter, fast exit) */
      gsap.to(oldFrame, {
        opacity: 0, y: dir > 0 ? -28 : 28,
        duration: 0.22, ease: 'power2.in', overwrite: 'auto',
        onComplete: function () { gsap.set(oldFrame, { pointerEvents: 'none' }); }
      });

      if (name) gsap.set(name, { yPercent: dir > 0 ? 65 : -65 });
      if (fn)   gsap.set(fn,   { opacity: 0, y: dir > 0 ? 14 : -14 });

      /* Enter — slower, expo.out */
      gsap.to(newFrame, {
        opacity: 1, y: 0, pointerEvents: 'auto',
        duration: 0.55, ease: EXPO, overwrite: 'auto'
      });
      if (name) gsap.to(name, { yPercent: 0, duration: 0.65, ease: EXPO, overwrite: 'auto' });
      if (fn)   gsap.to(fn,   { opacity: 1, y: 0, duration: 0.48, delay: 0.12, ease: EASE, overwrite: 'auto' });

      pips.forEach(function (p, j) {
        p.style.opacity         = j === newIdx ? '1' : '0.14';
        p.style.backgroundColor = j === newIdx ? '#4B8B2F' : '';
      });

      if (bgNum) bgNum.textContent = String(newIdx + 1).padStart(2, '0');
      curIdx = newIdx;
    }

    /* Switch frames from scroll PROGRESS through the tall section. No pin:true —
       the CSS-sticky child does the visual pinning, so this behaves identically
       in the editor and on the live storefront and survives reordering. */
    /* On phones, snap to one frame per scroll so a flick settles on a slide
       instead of skipping ahead. Desktop is left free (it already feels right). */
    var snapNarrow = window.innerWidth < 768;
    ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: 'bottom bottom',
      invalidateOnRefresh: true,
      snap: snapNarrow ? { snapTo: 1 / numFrames, duration: { min: 0.15, max: 0.4 }, delay: 0.08, ease: 'power2.inOut' } : false,
      onUpdate: function (self) {
        var newIdx = Math.min(Math.floor(self.progress * numFrames), numFrames - 1);
        showFrame(newIdx, self.direction);
      }
    });
  }

  /* ─── SECTION REVEALS ────────────────────────── */
  function initSectionReveals() {

    /* Headings — clip-path + y slide (Emil: never opacity-only) */
    gsap.utils.toArray('.th-sec-title, .th-science-title, .th-bundle-title, .th-coll-title, .th-page-title, .th-blog-title').forEach(function (el) {
      gsap.from(el, {
        scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' },
        yPercent: 55,
        clipPath: 'inset(0 0 100% 0)',
        duration: 0.90,
        ease: EXPO
      });
    });

    /* Section headers — stagger children fade-up */
    gsap.utils.toArray('.th-sec-header').forEach(function (el) {
      gsap.from(el.children, {
        scrollTrigger: { trigger: el, start: 'top 85%' },
        opacity: 0, y: 18, stagger: 0.08, duration: 0.65, ease: EASE
      });
    });

    /* Stats bar — count up with stagger */
    var statsBar = document.querySelector('.th-stats-bar');
    if (statsBar) {
      ScrollTrigger.create({
        trigger: statsBar,
        start: 'top 85%',
        once: true,
        onEnter: function () {
          gsap.from('.th-stat-cell', {
            opacity: 0, y: 18,
            stagger: 0.07, duration: 0.60, ease: EASE
          });

          statsBar.querySelectorAll('.th-stat-num').forEach(function (el) {
            var text  = el.textContent.trim();
            var match = text.match(/[0-9]+/);
            if (!match) return;
            var target = parseInt(match[0], 10);
            if (target === 0) return;
            var before  = text.slice(0, text.indexOf(match[0]));
            var after   = text.slice(text.indexOf(match[0]) + match[0].length);
            var counter = { n: 0 };
            gsap.to(counter, {
              n: target,
              duration: 1.4,
              ease: 'power2.out',
              onUpdate: function () { el.textContent = before + Math.round(counter.n) + after; }
            });
          });
        }
      });
    }

    /* Product cards — stagger with scale (Emil: scale(0.96), not scale(0)) */
    gsap.utils.toArray('.th-prod-grid').forEach(function (grid) {
      var cards = grid.querySelectorAll('.th-prod-card, a.th-prod-card, div.th-prod-card');
      if (!cards.length) return;
      gsap.from(cards, {
        scrollTrigger: { trigger: grid, start: 'top 82%' },
        opacity: 0,
        y: 28,
        scale: 0.97,
        stagger: { amount: 0.45, from: 'start' },
        duration: 0.75,
        ease: EXPO
      });
    });

    /* Bundle tiers */
    gsap.utils.toArray('.th-tier').forEach(function (tier, i) {
      gsap.from(tier, {
        scrollTrigger: { trigger: tier, start: 'top 88%' },
        opacity: 0,
        y: 14,
        duration: 0.55,
        delay: i * 0.05,
        ease: EASE
      });
    });

    /* Science / problem blocks */
    gsap.utils.toArray('.th-science-block, .th-prob-card').forEach(function (el) {
      gsap.from(el, {
        scrollTrigger: { trigger: el, start: 'top 85%' },
        opacity: 0,
        y: 22,
        duration: 0.75,
        ease: EXPO
      });
      var title = el.querySelector('.th-science-block-title, .th-prob-title');
      if (title) {
        gsap.from(title, {
          scrollTrigger: { trigger: title, start: 'top 88%' },
          yPercent: 40,
          clipPath: 'inset(0 0 100% 0)',
          duration: 0.85,
          ease: EXPO
        });
      }
    });

    /* Tags — stagger horizontal entrance */
    gsap.utils.toArray('.th-tag-cloud .th-tag').forEach(function (tag, i) {
      gsap.from(tag, {
        scrollTrigger: { trigger: tag, start: 'top 90%' },
        opacity: 0,
        x: 8,
        duration: 0.45,
        delay: i * 0.035,
        ease: EASE
      });
    });

    /* Generic fade-up fallback */
    gsap.utils.toArray('.th-fade-up').forEach(function (el) {
      gsap.from(el, {
        scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' },
        opacity: 0,
        y: 18,
        duration: 0.65,
        ease: EASE,
        onStart: function () { el.classList.add('th-visible'); }
      });
    });

    /* Ship strip */
    var ship = document.querySelector('.th-ship-strip');
    if (ship) {
      gsap.from(ship.children, {
        scrollTrigger: { trigger: ship, start: 'top 88%' },
        opacity: 0, y: 14, stagger: 0.10, duration: 0.65, ease: EASE
      });
    }
  }

  /* ─── CUSTOM CURSOR (light-mode colours) ─────── */
  /* lerp ring + instant dot. Emil: never use CSS cursor:none on touch. */
  function initCursor() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if ('ontouchstart' in window) return;

    var ring = document.createElement('div');
    ring.setAttribute('aria-hidden', 'true');
    ring.className = 'th-cursor-ring';
    ring.style.cssText = [
      'position:fixed', 'width:28px', 'height:28px',
      'border:1.5px solid rgba(75,139,47,0.45)', 'border-radius:50%',
      'pointer-events:none', 'z-index:99999',
      'transform:translate(-50%,-50%)', 'top:0', 'left:0',
      'transition:width 0.18s cubic-bezier(0.16,1,0.3,1),height 0.18s cubic-bezier(0.16,1,0.3,1),border-color 0.18s ease',
      'will-change:left,top'
    ].join(';');

    var dot = document.createElement('div');
    dot.setAttribute('aria-hidden', 'true');
    dot.className = 'th-cursor-dot';
    dot.style.cssText = [
      'position:fixed', 'width:4px', 'height:4px',
      'background:rgba(75,139,47,0.80)', 'border-radius:50%',
      'pointer-events:none', 'z-index:99999',
      'transform:translate(-50%,-50%)', 'top:0', 'left:0',
      'will-change:left,top'
    ].join(';');

    document.body.appendChild(ring);
    document.body.appendChild(dot);

    var mx = window.innerWidth / 2, my = window.innerHeight / 2;
    var rx = mx, ry = my;
    var LERP = 0.11;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px';
      dot.style.top  = my + 'px';
    });

    var INTERACTIVE = 'a,button,[role="button"],input,textarea,select,.th-qty-btn,.th-filter-btn,.th-tab-btn,.th-gallery-thumb,.th-prod-card,.th-hh-pkg,.th-tier';

    document.addEventListener('mouseover', function (e) {
      if (e.target.closest(INTERACTIVE)) {
        ring.style.width = '46px';
        ring.style.height = '46px';
        ring.style.borderColor = 'rgba(75,139,47,0.75)';
      }
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest(INTERACTIVE)) {
        ring.style.width = '28px';
        ring.style.height = '28px';
        ring.style.borderColor = 'rgba(75,139,47,0.45)';
      }
    });

    /* Scale down on press — Emil: ring mirrors the scale(0.97) button feedback */
    document.addEventListener('mousedown', function () {
      ring.style.width = '18px';
      ring.style.height = '18px';
    });
    document.addEventListener('mouseup', function () {
      ring.style.width = '28px';
      ring.style.height = '28px';
    });

    document.addEventListener('mouseleave', function () {
      ring.style.opacity = '0';
      dot.style.opacity  = '0';
    });
    document.addEventListener('mouseenter', function () {
      ring.style.opacity = '1';
      dot.style.opacity  = '1';
    });

    (function loop() {
      rx += (mx - rx) * LERP;
      ry += (my - ry) * LERP;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(loop);
    })();

    document.documentElement.style.cursor = 'none';
    var s = document.createElement('style');
    s.textContent = '*, a, button { cursor: none !important; }';
    document.head.appendChild(s);
  }

  /* ─── MOBILE NAV ──────────────────────────────── */
  var burger    = document.getElementById('th-burger');
  var mobileNav = document.getElementById('th-mobile-nav');
  var closeBtn  = document.getElementById('th-mobile-close');

  function closeMobileNav() {
    mobileNav.classList.remove('open');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('open');
      burger.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
    if (closeBtn) closeBtn.addEventListener('click', closeMobileNav);
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMobileNav);
    });
    /* Close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('open')) closeMobileNav();
    });
  }

  /* ─── GALLERY IMAGE CROSSFADE WITH BLUR ─────── */
  /* Emil: blur bridges the crossfade gap so you see one
     continuous object transforming, not two objects swapping. */
  var thumbs  = document.querySelectorAll('.th-gallery-thumb');
  var mainImg = document.getElementById('th-gallery-main-img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        if (t.dataset.src) {
          /* Apply blur during swap */
          mainImg.classList.add('is-swapping');
          setTimeout(function () {
            mainImg.src = t.dataset.src;
            mainImg.classList.remove('is-swapping');
          }, 180);
        }
      });
    });
  }

  /* ─── PRODUCT PAGE — QTY + TABS ────────────── */
  var BUNDLE = {
    1:{t:499,p:499,s:0}, 2:{t:799,p:399,s:199}, 3:{t:1099,p:366,s:398},
    4:{t:1399,p:349,s:597}, 5:{t:1599,p:319,s:896}, 6:{t:1799,p:299,s:1195},
    7:{t:1999,p:285,s:1494}, 8:{t:2199,p:274,s:1793}, 9:{t:2399,p:266,s:2092},
    10:{t:2599,p:259,s:2391}
  };
  function fmt(n) { return 'Rs.' + n.toLocaleString('en-IN'); }

  var qtyBtns  = document.querySelectorAll('.th-qty-btn');
  var priceEl  = document.getElementById('th-pd-price');
  var perBagEl = document.getElementById('th-pd-per-bag');
  var saveEl   = document.getElementById('th-pd-saving');
  var addBtn   = document.getElementById('th-add-cart-btn');
  var qtyInput = document.getElementById('th-qty-input');

  function updatePrice(qty) {
    var tier = BUNDLE[qty] || BUNDLE[1];
    if (priceEl)  priceEl.textContent  = fmt(tier.t);
    if (perBagEl && qty > 1) { perBagEl.textContent = fmt(tier.p) + '/bag'; perBagEl.style.display = ''; }
    else if (perBagEl) perBagEl.style.display = 'none';
    if (saveEl && tier.s > 0) { saveEl.textContent = 'Save ' + fmt(tier.s); saveEl.style.display = ''; }
    else if (saveEl) saveEl.style.display = 'none';
    if (addBtn) { addBtn.dataset.qty = qty; addBtn.dataset.price = tier.t; }
  }

  qtyBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      qtyBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var qty = parseInt(btn.dataset.qty, 10);
      if (qtyInput) qtyInput.value = qty;
      updatePrice(qty);
    });
  });

  /* Tabs */
  document.querySelectorAll('.th-tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.th-tab-btn').forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('.th-tab-pane').forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var pane = document.getElementById('th-tab-' + btn.dataset.tab);
      if (pane) pane.classList.add('active');
    });
  });

  /* FAQ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.th-faq-question');
    if (!btn) return;
    var item = btn.closest('.th-faq-item');
    if (!item) return;
    var open = item.classList.toggle('open');
    btn.setAttribute('aria-expanded', String(open));
  });

  /* Collection filter */
  var filterBtns = document.querySelectorAll('.th-filter-btn');
  var prodCards  = document.querySelectorAll('.th-prod-card');
  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var tag = btn.dataset.tag || 'all';
      prodCards.forEach(function (card) {
        card.style.display = (tag === 'all' || (card.dataset.tags || '').indexOf(tag) !== -1) ? '' : 'none';
      });
    });
  });

  /* Sticky bundle */
  var stickyBundle = document.getElementById('th-sticky-bundle');
  var stickyCount = 0;
  var pastGrid = false;
  function updateSticky() {
    if (!stickyBundle) return;
    var show = window.innerWidth < 768 && pastGrid && stickyCount < 6;
    stickyBundle.style.display = show ? 'flex' : 'none';
  }
  if (stickyBundle) {
    var collGrid = document.getElementById('th-coll-grid');
    window.addEventListener('scroll', function () {
      if (collGrid) { var r = collGrid.getBoundingClientRect(); pastGrid = r.top + r.height * 0.25 < 0; }
      updateSticky();
    }, { passive: true });
  }

  /* Cart count */
  function updateCartCount(n) {
    if (n !== undefined) { setCount(n); return; }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      setCount(c.item_count);
      stickyCount = c.item_count;
      updateSticky();
    }).catch(function(){});
  }
  function setCount(n) {
    var el = document.getElementById('cart-count');
    if (el) el.textContent = n > 0 ? n : '';
  }

  /* Ajax add to cart (collection / homepage cards) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.th-prod-add[data-variant]');
    if (!btn || btn.id === 'th-add-cart-btn') return;
    e.preventDefault(); e.stopPropagation();
    var vid = btn.dataset.variant;
    if (!vid) return;
    var orig = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    }).then(function () {
      btn.textContent = 'Added';
      updateCartCount();
      stickyCount++;
      updateSticky();
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
    }).catch(function () { btn.textContent = orig; btn.disabled = false; });
  });

  /* Product page add to cart */
  if (addBtn) {
    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var vid = addBtn.dataset.variant;
      var qty = parseInt(addBtn.dataset.qty || '1', 10);
      if (!vid) return;
      addBtn.textContent = 'Adding...';
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: qty })
      }).then(function () {
        addBtn.innerHTML = 'Added &mdash; <a href="/cart" style="color:var(--sage);text-decoration:underline">view cart</a>';
        updateCartCount();
        setTimeout(function () { addBtn.textContent = 'Add to cart'; addBtn.disabled = false; }, 3200);
      }).catch(function () { addBtn.textContent = 'Add to cart'; addBtn.disabled = false; });
    });
  }

  /* Cart qty controls */
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('th-qty-ctrl')) {
      var wrap = e.target.closest('[data-line]');
      if (!wrap) return;
      var disp = wrap.querySelector('.th-qty-display');
      var cur  = parseInt(disp ? disp.textContent : '1', 10);
      var next = Math.max(0, cur + (e.target.dataset.dir === 'up' ? 1 : -1));
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: wrap.dataset.line, quantity: next })
      }).then(function (r) { return r.json(); })
        .then(function (c) { updateCartCount(c.item_count); window.location.reload(); });
    }
    if (e.target.classList.contains('th-cart-remove')) {
      var w2 = e.target.closest('[data-line]');
      if (!w2) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: w2.dataset.line, quantity: 0 })
      }).then(function (r) { return r.json(); })
        .then(function (c) { updateCartCount(c.item_count); window.location.reload(); });
    }
  });

  /* ─── SHOPIFY THEME EDITOR SUPPORT ──────────────
     When editing in the Theme Editor, Shopify tears out and re-injects
     section HTML. Old ScrollTrigger instances point at detached nodes —
     killing them all and re-running init() restores every animation cleanly. */
  document.addEventListener('shopify:section:load', function () {
    if (typeof ScrollTrigger !== 'undefined') {
      ScrollTrigger.getAll().forEach(function (t) { t.kill(); });
    }
    initHeroCarousel();
    init();
    if (window.innerWidth < 768) initMobileReveal();
  });

  /* ─── BOOT ────────────────────────────────────── */
  /* Carousel runs immediately — does not depend on GSAP */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroCarousel);
  } else {
    initHeroCarousel();
  }

  updateCartCount();
  init();

})();
